import { useCallback } from 'react';
import { track as trackerTrack } from './tracker';

/**
 * useAnalytics — hook returning { track }.
 * Wraps the singleton tracker so components don't import it directly.
 */
export default function useAnalytics() {
  const track = useCallback((name, props = {}, value = null) => {
    trackerTrack(name, props, value);
  }, []);

  return { track };
}
